export const lightColors = {
  textPrimary: '#000000',
  textSecondary: '#666666',
  textTertiary: '#A6A6A6',
  textPrimaryInverse: '#FFFFFF',
  textSecondaryInverse: '#B3B3B3',
  textTertiaryInverse: '#666666',
  textDisabled: '#BFBFBF',
  textBrand: '#007FFF',
  textOnBrand: '#FFFFFF',
  textOnSelected: '#000000',
  textLink: '#156DEA',
  textLinkHover: '#1B5AD8',
  textLinkPressed: '#0D378B',
  textWarning: '#F27F0D',
  textNegative: '#E61A1A',
  textPositive: '#009933',
  textStatic: '#FFFFFF',
  textStaticInverse: '#000000',
  backgroundPrimary: '#F2F2F7',
  backgroundHover: '#EAEAEA',
  backgroundPressed: '#DEDEDE',
  backgroundL0: '#FFFFFF',
  backgroundL0Accessibility: '#FFFFFF',
  backgroundL1: '#EAEAEA',
  backgroundL2: '#DEDEDE',
  backgroundL3: '#CCCCCC',
  backgroundL1Alpha: 'rgba(0, 0, 0, 0.04)',
  backgroundL2Alpha: 'rgba(0, 0, 0, 0.08)',
  backgroundL3Alpha: 'rgba(0, 0, 0, 0.12)',
  backgroundSelected: '#007FFF',
  backgroundPrimaryInverse: '#000000',
  backgroundL1Inverse: '#262626',
  backgroundL2Inverse: '#333333',
  backgroundL3Inverse: '#404040',
  backgroundDisabled: '#EAEAEA',
  backgroundBrand: '#007FFF',
  backgroundBrandSubtle: 'rgba(0, 127, 255, 0.16)',
  backgroundBrandHover: '#156DEA',
  backgroundBrandPressed: '#1B5AD8',
  backgroundWarning: '#F27F0D',
  backgroundWarningSubtle: 'rgba(242, 127, 13, 0.16)',
  backgroundNegative: '#E61A1A',
  backgroundNegativeSubtle: 'rgba(230, 26, 26, 0.16)',
  backgroundPositive: '#009933',
  backgroundPositiveSubtle: 'rgba(0, 153, 51, 0.16)',
  backgroundStatic: '#FFFFFF',
  backgroundInverseStatic: '#000000',
  iconPrimary: '#000000',
  iconSecondary: '#666666',
  iconTertiary: '#A6A6A6',
  iconPrimaryInverse: '#FFFFFF',
  iconSecondaryInverse: '#B3B3B3',
  iconTertiaryInverse: '#666666',
  iconSelected: '#007FFF',
  iconDisabled: '#BFBFBF',
  iconBrand: '#007FFF',
  iconOnBrand: '#FFFFFF',
  iconOnSelected: '#000000',
  iconHover: '#1B5AD8',
  iconPressed: '#0D378B',
  iconInfo: '#666666',
  iconWarning: '#F27F0D',
  iconNegative: '#E61A1A',
  iconPositive: '#009933',
  iconStatic: '#FFFFFF',
  iconStaticInverse: '#000000',
  borderPrimary: '#DEDEDE',
  borderPrimaryAlpha: 'rgba(0, 0, 0, 0.08)',
  borderSecondaryAlpha: 'rgba(0, 0, 0, 0.04)',
  borderSubtle: '#EAEAEA',
  borderInverse: '#262626',
  borderSelected: '#156DEA',
  borderDisabled: '#EAEAEA',
  borderBrand: '#007FFF',
  borderBrandSubtle: '#B9DCFF',
  borderWarning: '#F27F0D',
  borderNegative: '#E61A1A',
  borderPositive: '#009933',
  borderStatic: '#DEDEDE',
  borderStaticInverse: '#000000',
  cartBackground: '#000000',
  cartSurface: '#262626',
  cartAvatarBackground: '#404040',
  cartBorder: '#262626',
  cartTextPrimary: '#FFFFFF',
  cartTextSecondary: '#B3B3B3',
  cartTextTertiary: '#666666',
  cartIconPrimary: '#FFFFFF',
  cartIconTertiary: '#666666',
  cartTipSelectedBackground: '#F2F2F7',
  cartTipSelectedText: '#000000',
  cartBarBackground: '#000000',
  cartBarTextPrimary: '#FFFFFF',
  cartBarTextSecondary: '#B3B3B3',
  calendarDayBackground: '#000000',
  calendarDayText: '#FFFFFF',
  avatarBackground: 'rgba(0, 0, 0, 0.12)',
  avatarText: '#666666',
  backgroundL1Selected: '#156DEA',
  l0: '#FFFFFF',
  l1: '#FFFFFF',
  overlayPrimary: 'rgba(0, 0, 0, 0.24)',
};

export const darkColors = {
  textPrimary: '#FFFFFF',
  textSecondary: '#B3B3B3',
  textTertiary: '#666666',
  textPrimaryInverse: '#000000',
  textSecondaryInverse: '#666666',
  textTertiaryInverse: '#A6A6A6',
  textDisabled: '#404040',
  textBrand: '#007FFF',
  textOnBrand: '#FFFFFF',
  textOnSelected: '#FFFFFF',
  textLink: '#007FFF',
  textLinkHover: '#279FFF',
  textLinkPressed: '#56B0FF',
  textWarning: '#F4983B',
  textNegative: '#EB4646',
  textPositive: '#31AD5A',
  textStatic: '#FFFFFF',
  textStaticInverse: '#000000',
  backgroundPrimary: '#1A1A1A',
  backgroundHover: '#1A1A1A',
  backgroundPressed: '#262626',
  backgroundL0: '#0D0D0D',
  backgroundL0Accessibility: '#262626',
  backgroundL1: '#262626',
  backgroundL2: '#333333',
  backgroundL3: '#404040',
  backgroundL1Alpha: 'rgba(255, 255, 255, 0.08)',
  backgroundL2Alpha: 'rgba(255, 255, 255, 0.12)',
  backgroundL3Alpha: 'rgba(255, 255, 255, 0.16)',
  backgroundSelected: '#007FFF',
  backgroundPrimaryInverse: '#F7F7F7',
  backgroundL1Inverse: '#333333',
  backgroundL2Inverse: '#404040',
  backgroundL3Inverse: '#4C4C4C',
  backgroundDisabled: '#262626',
  backgroundBrand: '#007FFF',
  backgroundBrandSubtle: 'rgba(0, 127, 255, 0.16)',
  backgroundBrandHover: '#279FFF',
  backgroundBrandPressed: '#56B0FF',
  backgroundWarning: '#F4983B',
  backgroundWarningSubtle: 'rgba(242, 127, 13, 0.16)',
  backgroundNegative: '#EB4646',
  backgroundNegativeSubtle: 'rgba(230, 26, 26, 0.16)',
  backgroundPositive: '#31AD5A',
  backgroundPositiveSubtle: 'rgba(0, 153, 51, 0.16)',
  backgroundStatic: '#FFFFFF',
  backgroundInverseStatic: '#000000',
  iconPrimary: '#FFFFFF',
  iconSecondary: '#B3B3B3',
  iconTertiary: '#666666',
  iconPrimaryInverse: '#000000',
  iconSecondaryInverse: '#666666',
  iconTertiaryInverse: '#A6A6A6',
  iconSelected: '#007FFF',
  iconDisabled: '#404040',
  iconBrand: '#007FFF',
  iconOnBrand: '#FFFFFF',
  iconOnSelected: '#FFFFFF',
  iconHover: '#279FFF',
  iconPressed: '#56B0FF',
  iconInfo: '#B3B3B3',
  iconWarning: '#F4983B',
  iconNegative: '#EB4646',
  iconPositive: '#31AD5A',
  iconStatic: '#FFFFFF',
  iconStaticInverse: '#000000',
  borderPrimary: '#333333',
  borderPrimaryAlpha: 'rgba(255, 255, 255, 0.08)',
  borderSecondaryAlpha: 'rgba(255, 255, 255, 0.04)',
  borderSubtle: '#1A1A1A',
  borderInverse: '#DEDEDE',
  borderSelected: '#007FFF',
  borderDisabled: '#1A1A1A',
  borderBrand: '#007FFF',
  borderBrandSubtle: '#0D378B',
  borderWarning: '#F4983B',
  borderNegative: '#EB4646',
  borderPositive: '#31AD5A',
  borderStatic: '#DEDEDE',
  borderStaticInverse: '#000000',
  cartBackground: '#F7F7F7',
  cartSurface: '#DEDEDE',
  cartAvatarBackground: '#4C4C4C',
  cartBorder: '#DEDEDE',
  cartTextPrimary: '#000000',
  cartTextSecondary: '#666666',
  cartTextTertiary: '#A6A6A6',
  cartIconPrimary: '#000000',
  cartIconTertiary: '#A6A6A6',
  cartTipSelectedBackground: '#1A1A1A',
  cartTipSelectedText: '#FFFFFF',
  cartBarBackground: '#F7F7F7',
  cartBarTextPrimary: '#000000',
  cartBarTextSecondary: '#666666',
  calendarDayBackground: '#F7F7F7',
  calendarDayText: '#000000',
  avatarBackground: 'rgba(255, 255, 255, 0.16)',
  avatarText: '#B3B3B3',
  backgroundL1Selected: '#279FFF',
  l0: '#0D0D0D',
  l1: '#0D0D0D',
  overlayPrimary: 'rgba(0, 0, 0, 0.72)',
};

export const Colors = {
  light: lightColors,
  dark: darkColors,
};
